<template>
  <article id="article-fees">
    <section id="section-fees-detail">
      <header class="header-fees">
        <i class="fal fa-money-bill-alt"></i>
        <h2>รายละเอียดการซื้อ</h2>
      </header>
      <ul class="fees-list">
        <li class="fees-item">
          <div class="fees-row">
            <div class="fees-col-first">
              มูลค่าขั้นต่ำของการซื้อ ครั้งแรก
              <span>( Initial )</span>
            </div>
            <div class="fees-col-second">{{ detail.minimum_initial | comma }} บาท</div>
          </div>
        </li>
        <li class="fees-item">
          <div class="fees-row">
            <div class="fees-col-first">
              มูลค่าขั้นต่ำของการซื้อ ครั้งต่อไป
              <span>( Additional )</span>
            </div>
            <div class="fees-col-second">{{ detail.minimum_subsequent | comma }} บาท</div>
          </div>
        </li>
      </ul>
    </section>

    <section id="section-fees-price" v-if="rows && rows.length > 0">
      <header class="header-fees">
        <i class="fal fa-hand-holding-usd"></i>
        <h2>ค่าธรรมเนียม</h2>
      </header>
      <ul class="fees-list">
        <li class="fees-item" v-for="(item, index) in rows" :key="index">
          <div class="fees-price-item">
            <h3>{{ item.th}}</h3>
            <span>{{ item.en }}</span>
            <div class="fees-price-row">
              <div class="fees-price-col-first">ตามหนังสือชี้ชวน</div>
              <div class="fees-price-col-second">
                {{ item.rate | decimal }}
                <template v-if="!checkIsNull(item.rate)">
                  %
                  <span v-if="item.disabledYear != true">ต่อปี</span>
                </template>
              </div>
            </div>
            <div class="fees-price-row">
              <div class="fees-price-col-first">เก็บจริง</div>
              <div class="fees-price-col-second">
                {{ item.actualvalue | decimal }}
                <template v-if="!checkIsNull(item.actualvalue)">
                  %
                  <span v-if="item.disabledYear != true">ต่อปี</span>
                </template>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
  </article>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      arrFees: [],
      masterHeader: [
        {
          th: "ค่าธรรมเนียมการขายหน่วยลงทุน",
          en: "(Front-end Fee)",
          disabledYear: true,
          priority: 1
        },
        {
          th: "ค่าธรรมเนียมการรับซื้อคืนหน่วยลงทุน",
          en: "(Back-end Fee)",
          disabledYear: true,
          priority: 2
        },
        {
          th: "ค่าธรรมเนียมการสับเปลี่ยนหน่วยลงทุนเข้า",
          en: "(SWITCHING IN)",
          disabledYear: true,
          priority: 3
        },
        {
          th: "ค่าธรรมเนียมการสับเปลี่ยนหน่วยลงทุนออก",
          en: "(SWITCHING OUT)",
          disabledYear: true,
          priority: 4
        },
        {
          th: "ค่าธรรมเนียมการจัดการ",
          en: "",
          disabledYear: false,
          priority: 5
        },
        {
          th: "ค่าธรรมเนียมและค่าใช้จ่ายรวมทั้งหมด",
          en: "",
          disabledYear: false,
          priority: 6
        }
      ]
    };
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: null
    }
  },
  computed: {
    rows() {
      var _fees = this.arrFees;
      _fees = this.findHeaderEN(_fees);
      return _fees;
    }
  },
  filters: {
    decimal: function(value) {
      var result = Number(value).toFixed(2);
      if (isNaN(result)) {
        return value == "-" ? "" : value;
      }
      return result;
    },
    comma: function(value) {
      if (!value && value != 0) {
        return "-";
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  watch: {
    async id(id) {
      await this.queryData(id);
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    if (this.id) {
      await this.queryData(this.id);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions("fund", ["findFundFee"]),
    async queryData(id) {
      let rs = await this.findFundFee(id);
      if (rs && rs.fees && rs.fees.length > 0) {
        this.arrFees = rs.fees;
      }
    },
    checkIsNull(rate) {
      var isRate = Number(rate).toFixed(2);
      if (isNaN(isRate)) {
        return true;
      }
      return false;
    },
    findHeaderEN(val) {
      var _headers = this.masterHeader;
      if (val) {
        var resultRows = val.filter(row => {
          var resultHeader = _headers.filter(header => {
            return row.feetypedesc.includes(header.th);
          });
          if (resultHeader.length > 0) {
            row["en"] = resultHeader[0].en || "";
            row["th"] = resultHeader[0].th || "";
            row["disabledYear"] = resultHeader[0].disabledYear || "";
            row["priority"] = resultHeader[0].priority || "";
            return true;
          }
          return false;
        });
        return resultRows.sort(this.compare);
      }
      return "";
    }
  }
};
</script>
<style lang="scss" scoped>
#article-fees {
  @extend %container-style;
  margin-top: 10px;
  @include multipleResponsive(phablet, tablet) {
    max-width: $max-width-tablet;
  }
  #section-fees-detail {
    margin: 20px 0;
    display: inline-block;
    width: 100%;
    border-radius: 4px;
    border: solid 1px $color-border;
  }
  #section-fees-price {
    margin: 20px 0;
    display: inline-block;
    width: 100%;
    border-radius: 4px;
    border: solid 1px $color-border;
  }
  #section-sectors {
    margin: 20px 0;
    display: inline-block;
    width: 100%;
    border-radius: 4px;
    border: solid 1px $color-border;
  }
  .external-link {
    color: $color-orange-finno;
    margin-left: 5px;
  }
  .header-fees {
    padding: 8px 16px;
    border-bottom: 1px solid $color-border;
    i {
      margin-right: 10px;
    }
    h2 {
      @extend %font-size-m;
      color: $color-normal-text;
      display: inline-block;
    }
  }
  .fees-list {
    list-style: none;
    margin: 0;
    padding: 0 8px;
    .fees-item {
      margin: 0;
      padding: 0 8px;
      &:not(:last-child) {
        border-bottom: 1px solid $color-border;
      }
    }
  }
  .fees-row {
    padding: 8px 0;
    .fees-col-first {
      @include finCol(9, 12, 0px, middle, true, true);
      @extend %font-size-ss;
      span {
        color: $color-secondary-text;
        @extend %font-size-ss;
      }
    }
    .fees-col-second {
      @include finCol(3, 12, 0px, middle, true, true);
      @extend %font-size-ss;
      color: $color-normal-text;
      text-align: right;
      font-weight: bold;
    }
  }
  .fees-price-item {
    margin-top: 20px;
    margin-bottom: 20px;
    h3 {
      @extend %font-size-ss;
      color: $color-normal-text;
      display: inline-block;
      margin-right: 10px;
    }
    span {
      @extend %font-size-ss;
      color: $color-secondary-text;
      display: inline-block;
    }
    .fees-price-row {
      padding: 0 8px;
      .fees-price-col-first {
        @include finCol(4, 12, 0px, middle, true, true);
        @extend %font-size-ss;
        color: $color-secondary-text;
        font-weight: bold;
      }
      .fees-price-col-second {
        @include finCol(8, 12, 0px, middle, true, true);
        @extend %font-size-ss;
        color: $color-normal-text;
      }
    }
  }
}
</style>